var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "t-signupTestimonial" }, [
    _c(
      "div",
      { staticClass: "t-signupTestimonial__slider" },
      [
        _c(
          "transition",
          { attrs: { name: _vm.slideTransition, mode: "out-in" } },
          [
            _vm.activeSlide == 1
              ? _c(
                  "div",
                  { key: "1", staticClass: "t-pos--rel t-width--100" },
                  [
                    _c("div", { staticClass: "t-signupTestimonial__wrapper" }, [
                      _c(
                        "div",
                        { staticClass: "t-signupTestimonial__content" },
                        [
                          _c(
                            "div",
                            { staticClass: "t-signupTestimonial__tags" },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "onboard.signupTestimonial.testimonial_1.tag1"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "onboard.signupTestimonial.testimonial_1.tag2"
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("p", {
                            staticClass: "t-signupTestimonial__header t-clamp",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "onboard.signupTestimonial.testimonial_1.title"
                                )
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "t-signupTestimonial__review t-clamp",
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "onboard.signupTestimonial.testimonial_1.review"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "t-signupTestimonial__footer" },
                        [
                          _c("div", { staticClass: "t-flex t-flex--aic" }, [
                            _c(
                              "div",
                              { staticClass: "t-signupTestimonial__avatar" },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/lib/assets/images/signup/sakshi-sharma-keka.svg"),
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "t-signupTestimonial__author t-mar--b-no",
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t(
                                          "onboard.signupTestimonial.testimonial_1.author"
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "t-signupTestimonial__department",
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t(
                                          "onboard.signupTestimonial.testimonial_1.role"
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "t-signupTestimonial__logo",
                            attrs: {
                              src: require("@/lib/assets/images/companies/keka-bw.svg"),
                              height: "36",
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.activeSlide == 2
              ? _c(
                  "div",
                  { key: "2", staticClass: "t-pos--rel t-width--100" },
                  [
                    _c("div", { staticClass: "t-signupTestimonial__wrapper" }, [
                      _c(
                        "div",
                        { staticClass: "t-signupTestimonial__content" },
                        [
                          _c(
                            "div",
                            { staticClass: "t-signupTestimonial__tags" },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "onboard.signupTestimonial.testimonial_2.tag1"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "onboard.signupTestimonial.testimonial_2.tag2"
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("p", {
                            staticClass: "t-signupTestimonial__header t-clamp",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "onboard.signupTestimonial.testimonial_2.title"
                                )
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "t-signupTestimonial__review t-clamp",
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "onboard.signupTestimonial.testimonial_2.review"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "t-signupTestimonial__footer" },
                        [
                          _c("div", { staticClass: "t-flex t-flex--aic" }, [
                            _c(
                              "div",
                              { staticClass: "t-signupTestimonial__avatar" },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/lib/assets/images/signup/shelby-b-argyle.svg"),
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "t-signupTestimonial__author t-mar--b-no",
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t(
                                          "onboard.signupTestimonial.testimonial_2.author"
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "t-signupTestimonial__department",
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t(
                                          "onboard.signupTestimonial.testimonial_2.role"
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "t-signupTestimonial__logo",
                            attrs: {
                              src: require("@/lib/assets/images/companies/argyle-bw.svg"),
                              height: "30",
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.activeSlide == 3
              ? _c(
                  "div",
                  { key: "3", staticClass: "t-pos--rel t-width--100" },
                  [
                    _c("div", { staticClass: "t-signupTestimonial__wrapper" }, [
                      _c(
                        "div",
                        { staticClass: "t-signupTestimonial__content" },
                        [
                          _c(
                            "div",
                            { staticClass: "t-signupTestimonial__tags" },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "onboard.signupTestimonial.testimonial_3.tag1"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "onboard.signupTestimonial.testimonial_3.tag2"
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("p", {
                            staticClass: "t-signupTestimonial__header t-clamp",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "onboard.signupTestimonial.testimonial_3.title"
                                )
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "t-signupTestimonial__review t-clamp",
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "onboard.signupTestimonial.testimonial_3.review"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "t-signupTestimonial__footer" },
                        [
                          _c("div", { staticClass: "t-flex t-flex--aic" }, [
                            _c(
                              "div",
                              { staticClass: "t-signupTestimonial__avatar" },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/lib/assets/images/signup/guilherme-furst-fasttrack.svg"),
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "t-signupTestimonial__author t-mar--b-no",
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t(
                                          "onboard.signupTestimonial.testimonial_3.author"
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "t-signupTestimonial__department",
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t(
                                          "onboard.signupTestimonial.testimonial_3.role"
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "t-signupTestimonial__logo",
                            attrs: {
                              src: require("@/lib/assets/images/companies/fasttrack-bw.svg"),
                              height: "30",
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "t-signupTestimonial__navigation" },
          [
            _c("t-button", {
              class: { active: _vm.activeSlide == 1 },
              attrs: { variant: "action" },
              on: {
                click: function ($event) {
                  return _vm.viewSlide(1)
                },
              },
            }),
            _vm._v(" "),
            _c("t-button", {
              class: { active: _vm.activeSlide == 2 },
              attrs: { variant: "action" },
              on: {
                click: function ($event) {
                  return _vm.viewSlide(2)
                },
              },
            }),
            _vm._v(" "),
            _c("t-button", {
              class: { active: _vm.activeSlide == 3 },
              attrs: { variant: "action" },
              on: {
                click: function ($event) {
                  return _vm.viewSlide(3)
                },
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "t-signupTestimonial__logos" }, [
      _c("div", { staticClass: "t-flex t-flex--aic" }, [
        _c("img", {
          attrs: {
            src: require("@/lib/assets/images/companies/aveva-bw.svg"),
            height: "14",
          },
        }),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: require("@/lib/assets/images/companies/chargebee-bw.svg"),
            height: "16",
          },
        }),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: require("@/lib/assets/images/companies/helpthemove-bw.svg"),
            height: "24",
          },
        }),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: require("@/lib/assets/images/companies/webengage-bw.svg"),
            height: "24",
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "t-flex t-flex--aic" }, [
        _c("img", {
          attrs: {
            src: require("@/lib/assets/images/companies/foundit-bw.svg"),
            height: "16",
          },
        }),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: require("@/lib/assets/images/companies/talent500-bw.svg"),
            height: "18",
          },
        }),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: require("@/lib/assets/images/companies/wipro-bw.svg"),
            height: "26",
          },
        }),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: require("@/lib/assets/images/companies/keka-bw.svg"),
            height: "28",
          },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }